<template>
    <div class="order-confirm">
        <template v-if="!code">
            <ContactCard type="add" add-text="请选择收货地址" v-if="addressInfo==''" @click="addressedit"></ContactCard>
            <Cell v-else is-link center icon="location-o" @click="addressedit">
                <template slot="title">
                    <span class="custom-title">{{addressInfo.name}}   {{addressInfo.mobile}}</span>
                    <span class="custom-title"></span>
                </template>
                <span slot="label">
             {{addressInfo.city}}  {{addressInfo.district}} {{addressInfo.address}}
            </span>
            </Cell>

            <Card
                    :num="skuInfo.amount"
                    :price="skuInfo.point"
                    :desc="skuInfo.gpname"
                    :title="skuInfo.gname"
                    :thumb="skuInfo.gpimgurl"
            >
                <div slot="price" class="price van-submit-bar__price">
                    <img :src="require('assets/img/common/coin.png')" class="coin" alt="">
                    <span class="price_num van-submit-bar__price van-submit-bar__price--integer">{{skuInfo.point}}</span>


                    <template v-if="skuInfo.price*1>0">
                        <span class="price-symbol"> + </span><span class="">¥</span> <span
                            class=" van-submit-bar__price van-submit-bar__price--integer">{{skuInfo.price}}</span>
                    </template>
                </div>
            </Card>
            <SubmitBar @submit="pay" :loading="paying" :disabled="paying" button-text="提交订单"
                       :price="orderDetail.payprice*1000"
                       :suffix-label="orderDetail.pointlabel"
            ></SubmitBar>
        </template>
        <template v-else>
            ...
        </template>
    </div>
</template>
<script>
    import "./index.less"
    import {ContactCard, Cell, Card, SubmitBar, CellGroup} from 'vant';

    export default {
        name: "orderConfirm",
        data() {
            return {
                paying: false,
                orderid: '',
                orderDetail: '',
                addressInfo: '',
                skuInfo: '',
                code: ""
            }
        },
        components: {
            ContactCard,
            Cell,
            Card,
            SubmitBar,
            CellGroup
        },
        methods: {
            init() {
                this.code = '';
                this.paying = false;
                let {code, state, wechatpay, orderid,goodsid} = this.$route.query

                if (wechatpay === 'yes') {
                    this.$toast.fail('您已经取消支付');
                    this.$router.replace({name: 'exchangedetail',params:{'goodsid':goodsid}})
                    return ;
                }
                if (wechatpay === 'fail') {
                    this.$toast.fail('支付失败');
                    this.$router.replace({name: 'exchangedetail',params:{'goodsid':goodsid}})
                    return ;
                }

                if (wechatpay === 'ok') {
                    this.$toast.success('支付成功');
                    this.$router.push({name: 'myOrders'})
                    return;
                }

                if (code && state === "authorize_wechat") {
                    this.code = code
                    this.pay();
                } else {
                    this.orderid = this.$route.params.orderid
                    this.getOrderAndAddressInfo();
                }
            },
            pay() {
                this.paying = true;
                if (this.orderDetail.payprice * 1 === 0) {
                    let query = {
                        orderid: this.orderid,
                        orderno: this.orderDetail.orderno,
                        uaid: this.addressInfo.id,
                        goodsid:this.skuInfo.gid
                    }
                    this.$api.pay.payOrder(query).then((res) => {
                        if (res.status * 1 === 200) {
                            this.$toast.success('兑换成功')
                            this.$router.push({name: "myOrders"})
                            return;
                        } else {
                            this.$router.replace({name: 'exchangedetail', params: {'goodsid': this.skuInfo.gid}})
                            this.init()
                        }
                    })
                    return
                } 
                if (!this.code) {
                    if (this.cf.isWeChat()) {
                        this.$storage.set('payinfo', {
                            orderid: this.orderid,
                            orderno: this.orderDetail.orderno,
                            uaid: this.addressInfo.id,
                            goodsid:this.skuInfo.gid
                        })
                        // return ;
                        this.$wechat.jsAuthorize()
                    } else {
                        this.$toast.fail("请在微信中打开当前页面")
                        this.paying = false
                    }
                } else {
                    this.$storage.get('payinfo').then((payinfo) => {
                        if (payinfo) {
                            Object.assign(payinfo, {code: this.code})
                            this.$api.pay.payOrder(payinfo).then((res) => {
                                if (res.status * 1 === 200 && res.data.shipment) {
                                    //走支付
                                    this.$wechat.jsPay(res.data.shipment, res.data.orderid,payinfo.goodsid)
                                    return;
                                }else {
                                    this.$router.replace({name: 'exchangedetail', params: {'goodsid': this.skuInfo.gid}})
                                    this.init()
                                }
                                // if (res.status * 1 === 200) {
                                //     this.$toast.success('兑换成功')
                                //     this.$router.push({name: "myOrders"})
                                // } else {
                                //     let {orderid, uaid} = payinfo;
                                //     this.$router.replace({name: 'exchangedetail', params: {'gid': this.skuInfo.gid}})
                                //     this.init()
                                // }
                            })
                        } else {
                            this.$router.push({name: 'index'})

                        }

                    })
                }
            },
            addressedit() {
                this.$storage.set('orderid', this.orderid);
                this.$router.push({
                    name: 'addressList',
                    params: {selectid: this.addressInfo == '' ? '' : this.addressInfo.id}
                })
            },
            getOrderAndAddressInfo() {
                Promise.all([this.$api.address.getAddressList(), this.$api.pay.orderDetail({
                    orderid: this.orderid,
                    type: 2
                })]).then((res) => {
                    try {
                        let addressList = res[0]['data']['list'];
                        for (var i in addressList) {
                            if (this.$route.params.uaid) {
                                if (addressList[i]['id'] * 1 === this.$route.params.uaid * 1) {
                                    this.addressInfo = addressList[i]
                                    break;
                                }
                            } else {
                                if (addressList[i]['isdefault'] * 1 === 1) {
                                    this.addressInfo = addressList[i]
                                    break;
                                }
                            }
                        }
                        this.orderDetail = res[1]['data']
                        this.orderDetail.pointlabel = `+${this.orderDetail.point}积分`
                        this.skuInfo = res[1]['data']['detail'][0]
                    } catch (e) {

                    }
                })

            }
        },
        created() {
            console.log(2)

        },
        mounted() {
            this.$nextTick(() => {
                this.init()
            })
        }

    }
</script>
